// extracted by mini-css-extract-plugin
export var backDescription = "card-job-module--back-description--c824e";
export var backSide = "card-job-module--back-side--4a1d3";
export var backSubtitle = "card-job-module--back-subtitle--41e9a";
export var backTitle = "card-job-module--back-title--568ed";
export var buttonEnable = "card-job-module--button-enable--9c660";
export var buttonWrapper = "card-job-module--button-wrapper--33c86";
export var card = "card-job-module--card--d0ee9";
export var frontImage = "card-job-module--front-image--42cf9";
export var frontMask = "card-job-module--front-mask--d9930";
export var frontSide = "card-job-module--front-side--626e0";
export var reversed = "card-job-module--reversed--80691";
export var root = "card-job-module--root--a0b2c";